import { OPEN_VOUCHER_MODAL, GET_VOUCHERS, CREATE_VOUCHER, DELETE_VOUCHER } from '../actions/types';

const INITIAL_STATE = {
    voucher_list: [],
    status: 'ok',
    filter: 'All',
    voucherModalOpen: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case OPEN_VOUCHER_MODAL:
            return {
                ...state,
                voucherModalOpen: action.payload
            }

        case GET_VOUCHERS:
            return {
                ...state,
                status: 'ok',
                voucher_list: action.payload
            }

        case CREATE_VOUCHER:
            if (action.payload) {
                if (action.payload.status === 200) {
                    return {
                        ...state,
                        status: 'ok',
                        voucherModalOpen: false,
                        voucher_list: action.payload.body
                    }    
                } else {
                    return {
                        ...state,
                        voucherModalOpen: false,
                        status: action.payload.text
                    }
                }
            } else {
                return {
                    ...state,
                    voucherModalOpen: false,
                    status: 'Create voucher failed'
                }
            }

        case DELETE_VOUCHER:
            if (action.payload) {
                return {
                    ...state,
                    status: 'ok',
                    voucher_list: action.payload
                }
            } else {
                return {
                    ...state,
                    status: 'Delete voucher failed'
                }
            }

        default:
            return state;
    }
};
